import { ShieldCheck, BadgeCheck } from "lucide-react";
import { IMAGES } from "@/lib/site";
import { Reveal } from "@/components/site/Reveal";

const PRODUCTS = ["Protein Shakes", "Antioxidant-Rich Drinks", "Gut-Friendly Drinks", "Hydration Formulas"];
const PILLARS = ["Convenience", "Hygiene", "Technology", "Premium Supplementation"];

export default function About() {
  return (
    <section id="about" data-testid="about" className="relative bg-[#D9F4CD] py-24 md:py-36 border-t border-[#17320B]/10 overflow-hidden">
      <img src={IMAGES.molecule} alt="" aria-hidden className="pointer-events-none absolute -left-24 bottom-0 w-[380px] opacity-10 select-none" />
      <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <div className="flex items-center gap-4 mb-12 md:mb-16">
            <span className="font-mono-eb text-xs uppercase tracking-[0.3em] text-[#7B9C62]">/ What Is TheMacroBar</span>
            <span className="h-px flex-1 bg-[#17320B]/15" />
          </div>
        </Reveal>

        <div className="grid lg:grid-cols-[1.15fr_0.85fr] gap-12 lg:gap-20">
          <Reveal>
            <h2 className="font-display uppercase text-3xl md:text-5xl lg:text-6xl tracking-tighter leading-[0.95] text-[#17320B]">
              A next-generation<br />
              <span className="text-[#7B9C62]">smart nutrition</span><br />
              experience.
            </h2>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="space-y-6 text-[#17320B]/75 text-base md:text-lg leading-relaxed">
              <p>
                Designed for gyms, universities, fitness clubs and high-performance spaces,
                TheMacroBar combines convenience, hygiene, technology and premium supplementation
                to deliver freshly mixed beverages instantly.
              </p>
              <p>
                From protein shakes and antioxidant-rich blends to gut-friendly drinks and hydration formulas, every
                serving is blended on demand. By merging intelligent dispensing systems with modern
                fitness culture, TheMacroBar transforms how people access functional nutrition.
              </p>

              <p className="border-l-2 border-[#17320B] pl-4 text-[#17320B]">
                Like any supplement, our protein shakes deliver their best results with
                <span className="font-semibold"> consistent, regular use</span> as part of your
                training and nutrition routine.
              </p>

              <div className="flex flex-col sm:flex-row gap-3 pt-1">
                <div data-testid="badge-fssai" className="flex items-center gap-3 rounded-sm border border-[#7B9C62]/50 bg-white px-4 py-3">
                  <BadgeCheck size={20} className="text-[#7B9C62] shrink-0" />
                  <span className="text-sm text-[#17320B]">FSSAI approved &amp; compliant</span>
                </div>
                <div data-testid="badge-tested" className="flex items-center gap-3 rounded-sm border border-[#7B9C62]/50 bg-white px-4 py-3">
                  <ShieldCheck size={20} className="text-[#7B9C62] shrink-0" />
                  <span className="text-sm text-[#17320B]">Every batch of raw material quality-tested</span>
                </div>
              </div>

              <div>
                <div className="font-mono-eb text-[10px] uppercase tracking-[0.2em] text-[#7B9C62] mb-3">On the menu</div>
                <div className="flex flex-wrap gap-2">
                  {PRODUCTS.map((p) => (
                    <span key={p} className="rounded-full border border-[#17320B]/20 bg-[#C2E9FF]/50 px-4 py-1.5 text-sm text-[#17320B]">
                      {p}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="mt-16 md:mt-20 grid grid-cols-2 md:grid-cols-4 border-t border-[#17320B]/15">
            {PILLARS.map((p, i) => (
              <div key={p} className="py-8 px-1 md:px-4 border-b md:border-b-0 border-[#17320B]/10">
                <div className="font-display text-2xl md:text-3xl text-[#17320B]/20">{String(i + 1).padStart(2, "0")}</div>
                <div className="font-display uppercase text-lg md:text-xl tracking-tight mt-2 text-[#7B9C62]">{p}</div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
